import { Parser } from "@siteimprove/alfa-parser";
import { Comma, Function, Token, } from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
import { Length } from "../numeric/index.js";
import { Value } from "../value.js";
import { BasicShape } from "./basic-shape.js";
const { either, map, option, separatedList } = Parser;
/**
 * {@link https://drafts.fxtf.org/css-masking/#funcdef-clip-rect}
 *
 * @public
 * @deprecated Deprecated as of CSS Masking Module Level 1
 */
export class Rectangle extends BasicShape {
    static of(top, right, bottom, left) {
        return new Rectangle(top, right, bottom, left);
    }
    _top;
    _right;
    _bottom;
    _left;
    constructor(top, right, bottom, left) {
        super("rectangle", Value.hasCalculation(top, right, bottom, left));
        this._top = top;
        this._right = right;
        this._bottom = bottom;
        this._left = left;
    }
    get top() {
        return this._top;
    }
    get right() {
        return this._right;
    }
    get bottom() {
        return this._bottom;
    }
    get left() {
        return this._left;
    }
    resolve(resolver) {
        return new Rectangle(this._top.resolve(resolver), this._right.resolve(resolver), this._bottom.resolve(resolver), this._left.resolve(resolver));
    }
    equals(value) {
        return (value instanceof Rectangle &&
            value._top.equals(this._top) &&
            value._right.equals(this._right) &&
            value._bottom.equals(this._bottom) &&
            value._left.equals(this._left));
    }
    hash(hash) {
        hash
            .writeHashable(this._top)
            .writeHashable(this._right)
            .writeHashable(this._bottom)
            .writeHashable(this._left);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            top: this._top.toJSON(),
            right: this._right.toJSON(),
            bottom: this._bottom.toJSON(),
            left: this._left.toJSON(),
        };
    }
    toString() {
        return `rect(${this._top}, ${this._right}, ${this._bottom}, ${this._left})`;
    }
}
/**
 * @public
 * @deprecated Deprecated as of CSS Masking Module Level 1
 */
(function (Rectangle) {
    function isRectangle(value) {
        return value instanceof Rectangle;
    }
    Rectangle.isRectangle = isRectangle;
    const parseLengthAuto = either(Length.parse, Keyword.parse("auto"));
    Rectangle.parse = map(Function.parse("rect", either(separatedList(parseLengthAuto, option(Token.parseWhitespace), 4, 4), separatedList(parseLengthAuto, Comma.parse, 4, 4))), ([_, [top, right, bottom, left]]) => Rectangle.of(top, right, bottom, left));
})(Rectangle || (Rectangle = {}));
//# sourceMappingURL=rectangle.js.map